import React, { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { Link2, FileText, CheckSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { toast } from 'sonner';
import { GRAVEDAD_COLOR } from './shared';

const API = process.env.REACT_APP_BACKEND_URL;

export function HuerfanosSection({ authHeader }) {
  const { data, isLoading } = useQuery({
    queryKey: ['acc-huerfanos'],
    queryFn: () => axios.get(`${API}/api/accidentes`, { headers: authHeader(), params: { sin_centro: true, limit: 500 } }).then(r => r.data),
  });
  if (isLoading) return <Skeleton className="h-40 w-full" />;
  return (
    <div className="space-y-2" data-testid="accidentes-huerfanos">
      <p className="text-[11px]" style={{ color: 'var(--vz-text-muted)' }}>
        Partes Delt@ cuya razón social o DNI del trabajador <strong>no coincide con ningún centro Valoriza</strong>.
        Usa el módulo de mapeo en Admin para resolverlos.
      </p>
      <div className="rounded-xl overflow-hidden" style={{ border: '1px solid var(--vz-border-subtle)' }}>
        <Table>
          <TableHeader>
            <TableRow style={{ background: 'var(--vz-bg-elevated)' }}>
              <TableHead className="text-xs">Referencia</TableHead>
              <TableHead className="text-xs">F. Accidente</TableHead>
              <TableHead className="text-xs">Trabajador</TableHead>
              <TableHead className="text-xs">Razón social</TableHead>
              <TableHead className="text-xs">Gravedad</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {(data?.items || []).map((a, i) => (
              <TableRow key={i} style={{ borderColor: 'var(--vz-border-subtle)' }}>
                <TableCell className="text-xs py-2 font-mono" style={{ color: '#F97316' }}>{a.n_referencia}</TableCell>
                <TableCell className="text-xs py-2 font-mono">{a.fecha_accidente}</TableCell>
                <TableCell className="text-xs py-2">{a.apellidos} {a.nombre}</TableCell>
                <TableCell className="text-xs py-2">{a.razon_social}</TableCell>
                <TableCell className="text-xs py-2">
                  <Badge style={{ background: (GRAVEDAD_COLOR[a.grado_lesion_label] || '#999') + '20', color: GRAVEDAD_COLOR[a.grado_lesion_label] || '#999' }}>{a.grado_lesion_label}</Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!data?.items?.length && <p className="text-center text-[11px] py-6" style={{ color: 'var(--vz-text-muted)' }}>No hay partes sin mapeo.</p>}
      </div>
    </div>
  );
}
